/**
 * H-3a end-user account session — the single place that stores, reads and
 * clears the OTP-login session token.
 *
 * Transport is currently a bearer token in localStorage, injected on
 * axiosNewPrivate only (see util/axios.ts). If the transport decision
 * (issue #1679 Q2) lands on cookies instead, this module is the one swap
 * point: keep the three functions, change their internals.
 */

import { getTenantName } from "../util";

// Tenant-scoped: on shared deployments (app.kolula.com/{slug}) and the
// integration tenant switcher, a token issued for tenant A must never ride
// on tenant B's requests (repo rule: reset state on tenant switch).
const accountSessionStorageKey = (): string =>
  `account_session:${getTenantName() ?? "default"}`;

export const getAccountSessionToken = (): string | null => {
  try {
    return localStorage.getItem(accountSessionStorageKey());
  } catch {
    // Storage unavailable (private mode / blocked) — treat as logged out.
    return null;
  }
};

export const setAccountSessionToken = (token: string): void => {
  try {
    localStorage.setItem(accountSessionStorageKey(), token);
  } catch {
    // Storage unavailable — the session simply won't survive a reload.
  }
};

export const clearAccountSessionToken = (): void => {
  try {
    localStorage.removeItem(accountSessionStorageKey());
  } catch {
    // Storage unavailable — nothing to clear.
  }
};
